import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { UserInfoType } from "./interface";
import { userInfoApi } from "@/services/user";
import { getOssFileUrl } from "@/services/common";

class UserStore {
  userInfo: UserInfoType = {}; // 用户信息
  isLogin = true; // 是否登录

  constructor() {
    makeAutoObservable(this);
    // 开启持久化存储
    makePersistable(this, {
      name: "userStore",
      properties: ["userInfo"],
      storage: window.localStorage,
    });
  }

  /** @description 改变用户信息 */
  setUserInfo(info: UserInfoType) {
    this.userInfo = info;
  }
  /** @description 改变是否登录 */
  setIsLogin(isLogin: boolean) {
    this.isLogin = isLogin;
  }
  /** @description 获取用户信息 */
  async getUserInfo() {
    const res = await userInfoApi();
    if (res.data?.code === 0) {
      const { data = {} } = res.data;
      const _userInfo = { is_push: 0, ...data };
      if (data?.avatar) {
        const avatar_res = await getOssFileUrl({ oss_key: data?.avatar || "" });
        if (avatar_res.data?.code === 0) {
          _userInfo.avatar = avatar_res.data?.data?.url || "";
        }
      }
      this.setUserInfo(_userInfo);
    }
  }
}

const userStore = new UserStore();

export default userStore;
